import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useAuth } from "../context/AuthContext";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

const SideBarAgency = ({ vendors,notify }) => {

  const { t } = useTranslation();
  // const [vendors, setVendors] = useState([])

  const { pathname } = useLocation();
  const [sideBarVendor, setSideBarVendor] = useState([]);

  const searchParams = new URLSearchParams(location.search);
  const vendorIdFromUrl = searchParams.get("vendor_id");
  const agencyIdFromUrl = searchParams.get("agency_id");


  const { user } = useAuth()


  const closeSidebar = () => {
    const rootId = document.getElementById("root");
    // search for the class slide-nav
    const wrapper = rootId.querySelector(".main-wrapper");
    if (wrapper) {
        wrapper.classList.remove("slide-nav");
    }
  };


  useEffect(() => {
    const datavendors = Array.isArray(vendors) ? vendors : JSON.parse(localStorage.getItem("sideBarVendor"))
    const isValid = Array.isArray(datavendors) && datavendors.length > 0;
    const isDifferent =
      isValid && JSON.stringify(datavendors) !== JSON.stringify(sideBarVendor);

    if (isDifferent) {
      setSideBarVendor(datavendors);
    }
  }, [vendors, sideBarVendor])


  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }

    document.addEventListener("mouseover", handleMouseOver);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="sidebar-vertical">

                 {/* Super */}
                      {user.super &&
                       <>
                    <li className="menu-title">
                    <span>{t("Super User")}</span>
                    </li>

                    
                    <li >
                    <Link to="/super-biodata" className={pathname === "/super-biodata" ? "active" : ""}>
                    <i className="fe fe-eye" /> <span>{t("Biodata Log")}</span>{" "}
                    </Link>
                    </li>
                     <li >
                    <Link to="/super-deleted-biodata" className={pathname === "/super-deleted-biodata" ? "active" : ""}>
                    <i className="fe fe-eye" /> <span>{t("Deleted Agency Biodata Log")}</span>{" "}
                    </Link>
                    </li>
                
                    <li>
                    <Link to="/super-users" className={(pathname === "/super-users") ? "active" : ""}>
                    <i className="fe fe-eye" /> <span>{t("Agencies log")}</span>{" "}
                    </Link>
                    </li>
                    
                    
                    </>
                    
                    


                    }

                    
                {/* Main */}
                <li className="menu-title">
                  <span>{t("Biodata")}</span>
                </li>

                <li >
                  <Link to="/biodata-form" className={pathname === "/biodata-form" ? "active" : ""}>
                    <i className="fe fe-user-plus" /> <span>{t("Add Biodata")}</span>{" "}

                  </Link>
                </li>
                
                <li >
                  <Link to="/biodata-form-extract" className={pathname === "/biodata-form-extract" ? "active" : ""}>
                    <i className="fe fe-user-plus" /> <span>{t("Extract Biodata")}</span>{" "}

                  </Link>
                </li>
                { /*
                  <li >
                  <Link
                    to="/"
                   
                    className={pathname === "/" || pathname === "/dashboard"? "active" : ""}
                  >
                    <i className="fe fe-home" /> <span>Available</span>{" "}
                  
                  </Link>
                  </li >
*/}
                <li>
                  <Link to="/allbiodata" className={pathname === "/allbiodata" && agencyIdFromUrl === null && !vendorIdFromUrl ? "active" : ""} onClick={closeSidebar}>
                    <i className="fe fe-users" /> <span>{t("All Biodata")}</span>{" "}
                  </Link>
                  </li>
                  <li>
                    <Link to={`/allbiodata?agency_id=${user.company.id}` } className={pathname === "/allbiodata" && agencyIdFromUrl === String(user.company.id) ? "active" : ""} onClick={closeSidebar}>
                      <i className="fe fe-users" /> <span>{user.company.name ?? localStorage.getItem("company_name") ?? 'My Biodata'}</span>
                    </Link>
                  </li>

                   {/* Vendor Biodata */}
                  {sideBarVendor && sideBarVendor.map((vendor) => (
                      <li key={vendor.id}>
                        <Link
                          onClick={closeSidebar}
                          to={`/allbiodata?vendor_id=${vendor.id}`}
                          className={
                            pathname === "/allbiodata" && vendorIdFromUrl === String(vendor.id)
                              ? "active"
                              : ""
                          }
                        >
                          <i className="fe fe-users" /> <span>{vendor.name}</span> {vendor.published_shared_count > 0 && <span>({vendor.published_shared_count})</span>}
                        </Link>
                      </li>
                    ))}

                {/* Booking */}
                <li className="menu-title">
                  <span>{t("Booking")}</span>
                </li>


                {/* <li>
                    <Link to="/booking/onhold" className={pathname === "/booking/onhold" ? "active" : ""}>
                    <i className="fe fe-pause-circle" /> <span>On-Hold</span>
                    </Link>
                </li> */}
                <li>
                      <Link style={{display:'flex',alignItems:'center'}} to="/booking" className={pathname === "/booking" ? "active" : ""}>
                  <i className="fe fe-book" /> <span>{t("Booking")}</span>
                  {pathname !== "/booking" &&notify.book && <span className="badge badge-danger rounded-pill ms-2" style={{
      width: '8px',
      height: '8px',
      backgroundColor: '#dc3545',
      border: 'none',
      padding: '0',
      display: 'inline-block',
  
    }}></span>}
                  </Link>
                </li>
               { /*<li>
                  <Link to="/booking/pending" className={pathname === "/booking/pending" ? "active" : ""}>
                    <i className="fe fe-loader" /> <span>{t("Pending")}</span>
                  </Link>
                  </li>*/}
              

                {/* Vendor */}
                <li className="menu-title">
                  <span>{t("Vendor")}</span>
                </li>

                <li>
                  <Link to="/vendor-list#" className={pathname === "/vendor-list" ? "active" : ""}>
                    <i className="fe fe-list" /> <span>{t("Vendor list")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/vendor-invitations" className={pathname === "/vendor-invitations" ? "active" : ""}>
                    <i className="fe fe-send" /> <span>{t("Invite Vendor")}</span>
                  </Link>
                </li>
                <li>
                    <Link style={{display:'flex',alignItems:'center'}} to="/invite/pending" className={pathname === "/invite/pending" ? "active" : ""}>
                    <i className="fe fe-loader" /> <span>{t("Vendor Invitations")}</span>
                     {pathname !== "/invite/pending" && notify.invited && <span className="badge badge-danger rounded-pill ms-2" style={{
      width: '8px',
      height: '8px',
      backgroundColor: '#dc3545',
      border: 'none',
      padding: '0',
      display: 'inline-block',
  
    }}></span>}
                    </Link>
                    </li>
                  

                {/* Employer */}
                {
                  user.company.is_premium && (
                   <>
                      <li className="menu-title">
                          <span>{t("Employer")}</span>
                      </li>

                      <li>
                        <Link to="/employer-management#" className={pathname === "/employer-management" ? "active" : ""}>
                          <i className="fe fe-list" /> <span>{t("Employer Management")}</span>
                        </Link>
                      </li>
                   </>
                  )
                }


                {/* Agency */}

                {
                  user.role == "Admin" && <>
                    <li className="menu-title">
                      <span>{t("Agency")}</span>
                    </li>

                    <li>
                      <Link to="/agency-details" className={pathname === "/agency-details" ? "active" : ""}>
                        <i className="fe fe-info" /> <span>{t("Agency Details")}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/staff" className={pathname === "/staff" ? "active" : ""}>
                        <i className="fe fe-users" /> <span>{t("Staff Management")}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/invitations" className={pathname === "/invitations" ? "active" : ""}>
                        <i className="fe fe-send" /> <span>{t("Invite Staff")}</span>
                      </Link>

                    </li>
                  </>
                }

       {/* Support */}
                    
                         <>
                            <li className="menu-title">
                                <span>{t("Support")}</span>
                            </li>
      
                            <li>
                              <Link to="/feedback" className={pathname === "/feedback" ? "active" : ""}>
                                <i className="fe fe-message-circle" /> <span>{t("Feedback")}</span>
                              </Link>
                            </li>
      
                             <li>
                              <Link to="/documentation?type=agency" className={pathname === "/documentation" ? "active" : ""}>
                                <i className="fe fe-book-open" /> <span>{t("Documentation Agency")}</span>
                              </Link>
                            </li>
<li>
                              <a href="/video-guide/"   target="_blank" 
  rel="noopener noreferrer">
                                <i className="fe fe-play" /> <span>{t("Video Guide")}</span>
                              </a>
                            </li>
                         </>
                 

              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

SideBarAgency.propTypes = {
  // fetchDataVendors: PropTypes.func.isRequired,
  vendors: [],
  notify: PropTypes.shape({
      book: PropTypes.bool,
      invited: PropTypes.bool,
    }),
  // setVendors: PropTypes.func.isRequired,
};

export default SideBarAgency;